'use strict';

var _classCallCheck = require("/home/keoadmin/agent/_work/111/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/111/s/node_modules/@babel/runtime/helpers/createClass.js");
var Warning = /*#__PURE__*/function () {
  function Warning(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Warning);
    this.type = 'warning';
    this.text = text;
    if (opts.node && opts.node.source) {
      var range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }
    for (var opt in opts) this[opt] = opts[opt];
  }
  _createClass(Warning, [{
    key: "toString",
    value: function toString() {
      if (this.node) {
        return this.node.error(this.text, {
          index: this.index,
          plugin: this.plugin,
          word: this.word
        }).message;
      }
      if (this.plugin) {
        return this.plugin + ': ' + this.text;
      }
      return this.text;
    }
  }]);
  return Warning;
}();
module.exports = Warning;
Warning.default = Warning;